export default __webpack_public_path__ + "static/ay-glossary-knowledge-desk-filter-icon-b4c9507f3a5809da317bd52c179b78e1.svg";